import { render } from "./Callback.vue?vue&type=template&id=b6474b2e"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import "./Callback.vue?vue&type=style&index=0&id=b6474b2e&lang=css"

import exportComponent from "C:\\agent\\_work\\55\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__